<template>
  <Modal
    @close="closeModal()"
    :closeIcon="true"
    size="sm"
    :withoutFooter="true"
  >
    <div slot="body">
      <h2 class="font-semibold text-2xl">Manage Team Members</h2>

      <TableComponent
        class="mt-4"
        v-if="sharedSeats && sharedSeats.length > 0"
        :data="sharedSeats"
        :headers="sharedSeatsColumns"
        :keys="['email', 'name']"
      >
        <template v-slot:buttons="{ row }">
          <ToggleButton
            class="flex justify-end"
            :state="row.active"
            :disabled="!canActivateSeats && !row.active"
            @change="state => changeSeatState(row, state)"
          />
        </template>
      </TableComponent>

      <div  class="flex mt-4">
        <input
          type="text"
          class="input mr-2"
          v-model="form.email"
          placeholder="Provide user email here"
        />
        <StyledButton
          @click="addSeat()"
          :disabled="!canSubmit"
          type="primary"
          :loading="loading"
        >
          Invite
        </StyledButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/common/Modal";
import StyledButton from "@/components/common/controls/StyledButton";
import TableComponent from "@/components/common/TableComponent";
import ApiV1 from "@/api/api_v1.0";
import ToggleButton from "@/components/common/controls/ToggleButton";

export default {
  name: "ManageTeamMembersModal",
  components: {
    Modal,
    StyledButton,
    TableComponent,
    ToggleButton
  },
  props: ["licenseid", "seats"],
  data() {
    return {
      sharedSeats: null,
      sharedSeatsColumns: [],
      loading: false,
      form: {
        email: null
      }
    };
  },

  async created() {
    this.loadSharedSeats();
  },

  methods: {
    async loadSharedSeats() {
      const response = await ApiV1.getSharedSeats(this.licenseid);
      const sharedSeats = response.data.map(item => {
        let fullname = "";

        if (item.first_name) {
          fullname = item.first_name + " ";
        }

        if (item.last_name) {
          fullname += item.last_name;
        }

        return {
          id: item.id,
          email: item.email,
          name: fullname,
          active: item.pivot.active
        };
      });
      this.sharedSeats = sharedSeats;
      this.sharedSeatsColumns = ["email", "name"];
    },

    closeModal() {
      this.$emit("close");
    },

    async changeSeatState(row, state) {
      await ApiV1.changeSharedSeatState(this.licenseid, {
        userid: row.id,
        state: state
      });
      this.loadSharedSeats();
      this.showGlobalSuccessMessage("Updated!");
    },

    async addSeat() {
      await ApiV1.addSharedSeats(this.licenseid, { email: this.form.email });
      this.loadSharedSeats();
      this.showGlobalSuccessMessage("Saved!");
      this.form.email = "";
    }
  },

  computed: {
    canSubmit() {
      return this.form.email && this.form.email.length > 3;
    },

    activeSharedSeats() {
      return this.sharedSeats.filter( seat => {
        return seat.active
      }).length
    },

    canActivateSeats() {
      return (
        this.activeSharedSeats < this.seats - 1
      );
    }
  }
};
</script>
